import type { FlagKey, FlagValue, FlagValues } from "../server/services/flags";

import { useGet } from "./http";

// Read a feature flag value resolved by the Vercel Flags dashboard rules.
//
// - Single shared fetch per session: every `useFlag` call reuses the same
//   query cache entry (keyed by URL), so only one request to /api/flags
//   is made.
// - Returns `undefined` until the response lands. Consumers that need to
//   block render can do `if (value === undefined) return <Spinner />`.
// - Returns `undefined` on fetch failure (no values cached) — same handling
//   as pre-hydration.
export const useFlag = <K extends FlagKey>(key: K): FlagValue<K> | undefined => {
  const { data } = useGet<FlagValues>("/api/flags", {
    staleTime: Infinity,
    retry: false,
  });
  return data?.[key];
};
